// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mIK3","label":"styles_label__1kz6K"};